export default __webpack_public_path__ + "static/6-aee2ecce9e27c73b5ec99e8c619d3780.jpg";